export const REPO_NAME = 'react-starwars';
